// The bottom tab bar below 1024 px (shell-ia §4.2; DESIGN-SYSTEM §00 over §2; 16 Oct 2026): an iOS tab bar in the bar material — ECONIC ·
// Agents · My workspace (or the administration set), 54 px plus the safe area, the active one in navy; below 768 px the phone dock adds
// the Ask bar with its context line above it. Agents is a plain tab to the Agents page, which lists the six. Should a set ever hold more
// than five, the fifth tab is "More", a menu with the rest — as iOS does — and it lights when one of them is open. WP-SHELL.
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router";
import { Check, Ellipsis } from "lucide-react";
import { useTranslation } from "@ncp/i18n";
import { Popover, PopoverContent, PopoverTrigger } from "@ncp/ui";
import { useWorkspace } from "../../app/workspace-context";
import { destinationOf, visibleDestinations } from "./destinations";
import { PhoneAskBar } from "./AgentColumn";

export function PhoneDock() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { can } = useWorkspace();
  const navigate = useNavigate();
  const [more, setMore] = useState(false);
  const { items } = visibleDestinations(can);
  const active = destinationOf(pathname);
  const tabs = items.length > 5 ? items.slice(0, 4) : items;
  const rest = items.length > 5 ? items.slice(4) : [];
  const inRest = rest.some((d) => d.id === active);
  return (
    <div className="es-dock econic-material-bar" data-print="hide" data-econic-dock="">
      <PhoneAskBar />
      <nav className="es-tabbar" aria-label={t("assistant:econic.shell.nav.destinations")}>
        {tabs.map((d) => {
          const Icon = d.icon;
          const current = active === d.id;
          return (
            <Link key={d.id} to={d.href} aria-current={current ? "page" : undefined} data-destination={d.id}>
              <Icon aria-hidden />
              <span>{t(`assistant:econic.shell.nav.${d.tab}`)}</span>
            </Link>
          );
        })}
        {rest.length > 0 ? (
          <Popover open={more} onOpenChange={setMore}>
            <PopoverTrigger asChild>
              <button type="button" aria-haspopup="menu" aria-expanded={more} aria-current={inRest ? "page" : undefined} data-destination="more">
                <Ellipsis aria-hidden />
                <span>{t("assistant:econic.shell.nav.moreTab")}</span>
              </button>
            </PopoverTrigger>
            <PopoverContent side="top" align="end" sideOffset={6} className="es-more-menu w-[240px] p-0">
              <div role="menu" aria-label={t("assistant:econic.shell.nav.moreTab")}>
                {rest.map((d) => {
                  const Icon = d.icon;
                  const current = active === d.id;
                  return (
                    <button key={d.id} type="button" role="menuitem" className="es-more-item" aria-current={current ? "page" : undefined}
                      onClick={() => { setMore(false); navigate(d.href); }}>
                      <Icon aria-hidden />
                      <span>{t(`assistant:econic.shell.nav.${d.label}`)}</span>
                      {current ? <Check aria-hidden className="ck" /> : null}
                    </button>
                  );
                })}
              </div>
            </PopoverContent>
          </Popover>
        ) : null}
      </nav>
    </div>
  );
}
